/* import __COLOCATED_TEMPLATE__ from './monitor-loading-state.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {
    isFailed: boolean;
  };
  Element: HTMLDivElement;
}

export default class MonitorLoadingState extends Component<Signature> {
  @service declare intl: IntlService;

  get titleText() {
    return this.intl.t('inbox.search.monitor-loading-state.title');
  }

  get bodyText() {
    return this.args.isFailed
      ? this.intl.t('inbox.search.monitor-loading-state.body-failed')
      : this.intl.t('inbox.search.monitor-loading-state.body-in-progress');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::MonitorLoadingState': typeof MonitorLoadingState;
    'inbox2/search/monitor-loading-state': typeof MonitorLoadingState;
  }
}
